/**
 * 驗證正整數
 * @param {String | Number} value arg
 * @param {String} errorMessage 錯誤訊息
 */
export const integer = (value, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    const digitsOnly = /^\d+$/.test(value);
    if (!digitsOnly) {
        return errorMessage || '請輸入正整數';
    }
};

/**
 * 驗證數字、浮點數
 * @param {String | Number} value arg
 * @param {String} num 判斷小數點後幾位
 * @param {String} errorMessage 錯誤訊息
 */
export const float = (value, num, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    const floatRegex = /^\d+(.[0-9]+)?$/;
    const floatWithNumRegex = num ? new RegExp(`^[0-9]+(.[0-9]{1,${num}})?$`) : '';
    if (!floatRegex.test(value)) {
        return errorMessage || '請輸入小數';
    }
    if (floatRegex.test(value) && num && !floatWithNumRegex.test(value)) {
        return errorMessage || `僅可輸入至小數位後${num}位數`;
    }
};

/**
 * 驗證最大最小值
 * @param {String | Number} value arg
 * @param {String} min 最小值
 * @param {String} max 最大值
 * @param {String} fieldName 欄位名稱
 * @param {String} errorMessage 錯誤訊息
 */
export const minMax = (value, min, max, fieldName, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    fieldName = fieldName || '';
    const numericValue = Number(value);
    const maxNum = Number(max);
    if (numericValue < min || numericValue > maxNum) {
        // let msg = `${fieldName}請輸入介於${min}~${max}之數字`;
        // if (errorMessage) msg = errorMessage;
        return errorMessage || `${fieldName}請輸入介於${min}~${max}之數字`;
    }
};

/**
 * 至多不超過
 * @param {String | Number} value arg
 * @param {String} max 最大值
 * @param {String} errorMessage 錯誤訊息
 */
export const maxValidate = (value, max, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    if (Number(value) > Number(max)) {
        return errorMessage || `請輸入小於${max}之數字`;
    }
};
/**
 * 至少大於ＸＸ
 * @param {String | Number} value arg
 * @param {String} max 最大值
 * @param {String} errorMessage 錯誤訊息
 */
export const minValidate = (value, min, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    const numericValue = Number(value);
    min = Number(min);
    if (numericValue < min) {
        return errorMessage || `請輸入大於${min}之數字`;
    }
};
/**
 * 驗證email
 * @param {String | Number} value arg
 * @param {String} fieldName 欄位名稱
 * @param {String} errorMessage 錯誤訊息
 */
export const email = (value, fieldName, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    fieldName = fieldName || '';
    const emailRegex = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+[a-zA-z]+$/;
    if (!emailRegex.test(value.toString())) {
        return errorMessage || `${fieldName}請輸入有效之E-mail`;
    }
};

/**
 * 驗證mobile
 * @param {String | Number} value arg
 * @param {String} reference 國碼
 * @param {String} fieldName 欄位名稱
 * @param {String} errorMessage 錯誤訊息
 */
export const mobile = (value, reference, fieldName, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    fieldName = fieldName || '';
    const digitsOnly = /^\d+$/.test(value);
    if (!digitsOnly) {
        return errorMessage || `${fieldName}請輸入有效之行動電話`;
    } else if (reference.toString() === '886' && !(value.length === 10 && /^09\d{8}$/.test(value))) {
        return errorMessage || `${fieldName}請輸入格式為09XXXXXXXX`;
    } else if (reference.toString() !== '886' && /^09+/.test(value)) {
        return errorMessage || `${fieldName}請輸入有效之行動電話`;
    }
};

/**
 * 驗證englishName
 * @param {String} value arg
 * @param {String} fieldName 欄位名稱
 * @param {String} errorMessage 錯誤訊息
 */
export const englishName = (value, fieldName, errorMessage) => {
    value = String(value);
    if (!value || !value.length) {
        return;
    }
    fieldName = fieldName || '';
    // const englishOnly = /^[a-z_A-Z]+[a-z_A-Z-.,\s]*[a-z_A-Z]+$/.test(value);
    const englishOnly = /^[a-zA-Z]+(?:[\s-.,_][a-zA-Z]+)*$/.test(value);
    const englishLast = /[a-zA-Z\s]+$/.test(value);
    const moreThanTwoWords = value.length > 2;
    if (!englishOnly || !englishLast || !moreThanTwoWords) {
        return errorMessage || `${fieldName}請輸入半型英文或「-」「.」「,」「_」`;
    }
};

/**
 * 驗證字數
 * @param {String} value arg
 * @param {Number} min 至少字數
 * @param {Number} max 至多字數
 * @param {String} errorMessage 錯誤訊息
 */
export const textLength = ({ value, min, max, fieldName }) => {
    const val = value ? String(value) : '';
    const valueLength = val.length;
    let message = '';

    if (max && valueLength > max) {
        message = `至多${max}字元`;
    } else if (min && (!val || !valueLength)) {
        message = `請輸入${fieldName}`;
    } else if (min && valueLength < min) {
        message = `至少${min}字元`;
    }
    return { val, message };
};

/**
 * 驗證身分證字號
 * @param {String} value arg
 * @param {String} errorMessage 錯誤訊息
 * @param {Boolean} isMustHave 是否必填
 */
export const IDnumber = ({ value, errorMessage, isMustHave }) => {
    const val = value.trim() ? String(value).trim().toUpperCase() : '';
    let message = '';

    if (!val || !val.length) {
        if (!isMustHave) {
            return { val, message };
        }
    }
    if (value.length < 10 || value.length > 10) {
        message = '請輸入身分證號碼共10碼';
    } else if (!(/^[A-Za-z@]\d{9}$/.test(value))) {
        message = errorMessage || '請輸入正確身分證字號';
    }

    return { val, message };
};
/**
 * 驗證英數
 * @param {String} value arg
 * @param {String} errorMessage 錯誤訊息
 * @param {Boolean} isMustHave 是否必填
 */
export const localAndForeignID = ({ value, errorMessage, isMustHave }) => {
    const val = value.trim() ? String(value).trim().toUpperCase() : '';
    let message = '';

    if (!val || !val.length) {
        if (!isMustHave) {
            return { val, message };
        }
    }
    if (!(/^[A-Za-z@\d]{8,10}$/.test(value))) {
        message = errorMessage || '請輸入有效之身分證字號';
    }

    return { val, message };
};

/**
* 驗證數字欄位
* @param {Number} type 驗證方法
* @param {String|Number} value arg
* @param {String} integerMsg 客制錯誤訊息：整數
* @param {String} minMaxMsg 客制錯誤訊息：介於
* @param {String} minMsg 客制錯誤訊息：至少
* @param {String} maxMsg 客制錯誤訊息：至多
* @param {Number} minNum 最少數字
* @param {Number} maxNum 最多數字
* @param {Number} floatNum 接受小數點第幾位
* @param {Number} floatMsg 客制錯誤訊息:小數點第幾位
*/
export const intMinMax = ({ value, integerMsg, minMaxMsg, minMsg, maxMsg, type = 1, minNum = 0, maxNum = 9999999, floatNum, floatMsg }) => {
    let val = 0;
    let errorMessage = '';
    if (floatNum) {
        if (isNaN(Number(value))) {
            errorMessage = '請輸入正整數或小數';
            val = value;
        } else if (!value) {
            val = 0;
            errorMessage = '請輸入數值';
        } else {
            value = String(value);
            if (value >= 1) {
                val = value.replace(/^[0]*/, '');
            } else if (value > 0 && value < 1) {
                val = value.replace(/^[0]*/, '0');
            } else {
                val = value;
            }
            errorMessage = float(val, floatNum, floatMsg);
        }
    } else {
        val = isNaN(Number(value)) ? value : Number(value);
        errorMessage = integer(val, integerMsg);
    }
    if (!errorMessage) {
        switch (type) {
            case 1: // between
                errorMessage = minMax(val, minNum, maxNum, '', minMaxMsg) || '';
                break;
            case 2: // min & max
                errorMessage = minValidate(val, minNum, minMsg) || maxValidate(val, maxNum, maxMsg) || '';
                break;
        }
    }
    return { val, errorMessage };
};
